import { useQuery } from '@tanstack/react-query';
import { Language, LanguagesApiResponse } from '../../../types/language-types';
import useGlynt from '../useGlynt';

function transformResponse(data: LanguagesApiResponse | undefined): Language[] {
  if (!data) return [];

  return Object.entries(data).map(([name, code]) => ({
    name,
    code,
  }));
}

export default function useGetAllLanguages() {
  const glynt = useGlynt();

  const { data, isError, isPending, isFetching, refetch } = useQuery({
    queryKey: ['languages'],

    queryFn: async () => {
      return (await glynt).language.getLanguages();
    },

    refetchOnWindowFocus: false
  });

  return {
    isPending,
    isLoading: isPending,
    isError,
    isFetching,
    data: transformResponse(data),
    refetch,
  };
}
